import {createSlice} from "@reduxjs/toolkit";
import {LeadInterface} from "@/interfaces/leadInterface";
import Nullable from "@/types/utils/Nullable";
import State from "@/types/utils/State";

interface IUserLoad{
    cd_oferta: Nullable<string>
    email: Nullable<string>
    telefone: Nullable<string>
}

export interface IOfferLoad{
    cd_oferta: Nullable<string>
    id: Nullable<string>
    valor: {
        valor: Nullable<string>
    }
}

const data: LeadInterface = {
    offer: null,
    city: null,
    name: null,
    phone: null,
    mobile: null,
    email: null,
    origemVda: null,
    cpfCnpj: null,
    idLead: null,
    campanha: null,
    parcela: null,
    valor: null,
    cep: null,
    TENTATIVA_TEF: 'N',
    flEntrega: 'N',
    url: null,
};

const initialState: State<LeadInterface> = {
    value: data,
}

export const leadSlice = createSlice({
    name: "lead",
    initialState,
    reducers: {
        SET_LEAD_CIDADE: (state, {payload}: { payload: string }) => {
            state.value.city = payload
        },
        SET_LEAD_NOME: (state, {payload}: { payload: string }) => {
            state.value.name = payload
        },
        SET_LEAD_CELULAR: (state, {payload}: { payload: string }) => {
            state.value.mobile = payload
        },
        SET_LEAD_EMAIL: (state, {payload}: { payload: string }) => {
            state.value.email = payload
        },
        SET_LEAD_ORIGEM_VENDA: (state, {payload}: { payload: number }) => {
            state.value.origemVda = payload
        },
        SET_LEAD_DOCUMENTO: (state, {payload}: { payload: string }) => {
            state.value.cpfCnpj = payload
        },
        SET_LEAD_CEP: (state, {payload}: { payload: string }) => {
            state.value.cep = payload
        },
        SET_LEAD_PARCELA: (state, {payload}: { payload: string }) => {
            state.value.parcela = payload
        },
        SET_LEAD_ID: (state, {payload}: { payload: number }) => {
            state.value.idLead = payload
        },
        SET_LEAD_TENTATIVA_TEF: (state, {payload}: { payload: 'S' | 'N' }) => {
            state.value.TENTATIVA_TEF = payload
        },
        SET_LEAD_OFFER_LOAD: (state, {payload}: {payload: IOfferLoad | any}) => {
            state.value.offer = payload.cd_oferta
            state.value.campanha = payload.id
            if(payload.valor.valor !== null){
                state.value.valor = payload.valor.valor
            }
        },
        SET_LEAD_USER_LOAD: (state, {payload}: {payload: IUserLoad}) => {
            state.value.cpfCnpj = payload.cd_oferta
            state.value.email = payload.email
            state.value.mobile = payload.telefone
        },
        SET_LEAD_URL: (state, {payload}: {payload: Nullable<string>}) => {
            state.value.url = payload
        }
    }
})

export const {SET_LEAD_URL} = leadSlice.actions
export const {SET_LEAD_USER_LOAD} = leadSlice.actions
export const {SET_LEAD_OFFER_LOAD} = leadSlice.actions
export const {SET_LEAD_ID} = leadSlice.actions
export const {SET_LEAD_CIDADE} = leadSlice.actions
export const {SET_LEAD_NOME} = leadSlice.actions
export const {SET_LEAD_CELULAR} = leadSlice.actions
export const {SET_LEAD_EMAIL} = leadSlice.actions
export const {SET_LEAD_ORIGEM_VENDA} = leadSlice.actions
export const {SET_LEAD_DOCUMENTO} = leadSlice.actions
export const {SET_LEAD_CEP} = leadSlice.actions
export const {SET_LEAD_PARCELA} = leadSlice.actions
export const {SET_LEAD_TENTATIVA_TEF} = leadSlice.actions
export const GET_LEAD = (state: any): LeadInterface => state.lead.value

export default leadSlice.reducer